export default "__VITE_ASSET__BmZrEPSC__"